
window.isiOS = function() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

/** play() promise: AbortError (pause/load/background power-save) → info only; other errors unchanged. */
window['playLuckyBallsVideo'] = function (video) {
  if (!video || typeof video.play !== 'function') {
    return;
  }
  video.play().catch(function (e) {
    if (e && e.name === 'AbortError') {
      //console.info('[lucky-balls] Video play interrupted (AbortError):', e.message);
      return;
    }
    throw e;
  });
};

window['getMostCommonColors'] = function() {
    // create temp array for sorting
    var tempArray = [];
    for (var key in window['drawnColors']) {
        tempArray.push(window['drawnColors'][key]);
    }

    // sort temp array descending
    var sorted = tempArray.sort(function(a, b) {
        return b - a
    });

    // get most common colors
    var colors = [];
    for (var key in drawnColors) {
        if (drawnColors[key] == sorted[0]) {
            colors.push(key);
        }
    }

    return colors;
}

window['countdown'] = function(timeInSeconds) {
    var minutes = Math.floor(timeInSeconds / 60);
    var seconds = timeInSeconds - minutes * 60;
    var endTime, hours, mins, msLeft, time;

    function twoDigits(n) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if (msLeft < 31000) {
            scene.elements.countdown.setX(313).setText(langArr[language].last_bets);
        } else {
            time = new Date(msLeft);
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            var countdownTime = (hours ? hours + ':' + twoDigits(mins) : mins) + ':' + twoDigits(time.getUTCSeconds());
            if ('undefined' !== typeof scene.elements.countdown)
                scene.elements.countdown.setText(countdownTime);
            setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
    }

    endTime = (+new Date) + 1000 * (60 * minutes + seconds) + 500;
    updateTimer();
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/common.js
// module id = 866
// module chunks = 0